export default __webpack_public_path__ + "static/plugins/daypilot/month_green.css";